import http from '@/utils/http' //引入axios
export const getCleanRecord = data => http.get('/maintenance-center/api/cleanrecord', {
    params: data
}) //查找清洁数据
export const updataCleanRecord = data => http.put('/maintenance-center/api/cleanrecord', data) //編輯清洁数据
export const addCleanRecord = data => http.post('/maintenance-center/api/cleanrecord', data) //添加清洁数据
export const deleteCleanRecord = data => http.delete('/maintenance-center/api/cleanrecord', {
    params: data
}) //刪除清洁数据
// 导出清洁数据
export const exportCord = data => http.get('/maintenance-center/api/cleanrecord/excel', {
    params: data,
    responseType: 'blob'
})
export default {
    getCleanRecord,
    updataCleanRecord,
    addCleanRecord,
    deleteCleanRecord,
    exportCord
}